import type { FloorPlanRecord } from "components/SmartSurveyor/SmartSurveyorForRudolfFritz/hooks/types";

export const planComparisonDataKeys = {
  all: ["quantitySurveyorFloorPlanData"] as const,
  plan: (record: FloorPlanRecord) =>
    [...planComparisonDataKeys.all, record] as const,
};
